import { componentName, TimerClass } from './TimerClass';
import '@descope-ui/descope-icon';

customElements.define(componentName, TimerClass);

export { TimerClass, componentName };
